import { connect } from 'react-redux';

import { deleteById, Entities, fetchAll, getEntities, patch } from 'src/common/index';
import OperatorStoreAdministration from 'src/components/superadmin/modules/operator-store/operator-store-administration';
import { upload } from 'src/actions/documents';

const mapStateToProps = state => {
    return {
        storeModules: getEntities(state, Entities.STORE_MODULES),
    };
};

const OperatorStoreAdministrationContainer = connect(mapStateToProps, {
    deleteById,
    fetchAll,
    patch,
    upload,
})(OperatorStoreAdministration);

export default OperatorStoreAdministrationContainer;
